import { createSlice } from '@reduxjs/toolkit';
import { saveSecureData, getSecureData } from '../../utils/secureStorage';

const initialState = {
  isAcceptUserTerms: false,
  isCardLimit: false,
  isStartSpend: false,
  isSessionId: getSecureData('isSessionId') || '',
  isCookieId: getSecureData('isCookieId') || '',
  isTokenExpiresOn: getSecureData('isTokenExpiresOn') || null,
  isSaldoCarteira: '',
  isStatusCarteira: '',
  isClientId: '',
  isUserName: '',
  isHasAccess: getSecureData('isHasAccess') || false,
  isAccessToken: getSecureData('isAccessToken') || '',
  isAssociatedInsuraceList: JSON.parse(getSecureData('isAssociatedInsuraceList')) || {
    policyNumber: '',
    amount: '',
    dueDate: '',
    nib: '',
    receiptNumber: '',
    cardNumber: ''
  },
  isMudaStatusNoti: true,
  isCategoryState: false,
  isNAssocia: getSecureData('isNAssocia') || '1',
  isQuantCartoes: '',
  isRedirectUrl: getSecureData('isRedirectUrl') || '',
  isPartnerName: getSecureData('isPartnerName') || '',
  isRefreshConsultaDeducoes: false,
  isRefreshGastarSaldo: false
};

const onboardingUserDataSlice = createSlice({
  name: 'onboardingUserData',
  initialState,
  reducers: {
    setAcceptUserTerms(state, action) {
      state.isAcceptUserTerms = action.payload;
    },
    setCardLimit(state, action) {
      state.isCardLimit = action.payload;
    },
    setStartSpend(state, action) {
      state.isStartSpend = action.payload;
    },
    setSessionId(state, action) {
      state.isSessionId = action.payload;
      saveSecureData('isSessionId', action.payload);
    },
    setCookieId(state, action) {
      state.isCookieId = action.payload;
      saveSecureData('isCookieId', action.payload);
    },
    setTokenExpiresOn(state, action) {
      state.isTokenExpiresOn = action.payload;
      saveSecureData('isTokenExpiresOn', action.payload);
    },
    setSaldoCarteira(state, action) {
      state.isSaldoCarteira = action.payload;
    },
    setStatusCarteira(state, action) {
      state.isStatusCarteira = action.payload;
    },
    setClientId(state, action) {
      state.isClientId = action.payload;
    },
    setUserName(state, action) {
      state.isUserName = action.payload;
    },
    setHasAccess(state, action) {
      state.isHasAccess = action.payload;
      saveSecureData('isHasAccess', action.payload);
    },
    setAccessToken(state, action) {
      state.isAccessToken = action.payload;
      saveSecureData('isAccessToken', action.payload);
    },
    setAssociatedInsuraceList(state, action) {
      state.isAssociatedInsuraceList = action.payload;
      saveSecureData('isAssociatedInsuraceList', JSON.stringify(action.payload));
    },
    setMudaStatusNoti(state, action) {
      state.isMudaStatusNoti = action.payload;
    },
    setCategoryState(state, action) {
      state.isCategoryState = action.payload;
    },
    setNAssocia(state, action) {
      state.isNAssocia = action.payload;
      saveSecureData('isNAssocia', action.payload);
    },
    setQuantCartoes(state, action) {
      state.isQuantCartoes = action.payload;
    },
    setRedirectUrl(state, action) {
      state.isRedirectUrl = action.payload;
      saveSecureData('isRedirectUrl', action.payload);
    },
    setPartnerName(state, action) {
      state.isPartnerName = action.payload;
      saveSecureData('isPartnerName', action.payload);
    },
    setRefreshConsultaDeducoes(state, action) {
      state.isRefreshConsultaDeducoes = action.payload;
    },
    setRefreshGastarSaldo(state, action) {
      state.isRefreshGastarSaldo = action.payload;
    },
  }
});

export const { setAcceptUserTerms, setCardLimit, setStartSpend, setSessionId, setCookieId, setTokenExpiresOn, setSaldoCarteira, setStatusCarteira, setClientId, setUserName, setHasAccess, setAccessToken, setAssociatedInsuraceList, setMudaStatusNoti, setCategoryState, setNAssocia, setQuantCartoes, setRedirectUrl, setPartnerName, setRefreshConsultaDeducoes, setRefreshGastarSaldo } = onboardingUserDataSlice.actions;
export default onboardingUserDataSlice.reducer;
